import styled from '@emotion/styled';
import { Sparkles } from 'lucide-react';

// The AI's face on the dashboard (decision 2026-10-19): the bluish star the
// final report shows above the EU AI label (PublicWorkshopReport header,
// Sparkles in #7c3aed). Decorative next to text that already says it is AI.
const AiAvatar = styled(Sparkles)`
  width: clamp(18px, 2.2vmin, 52px);
  height: clamp(18px, 2.2vmin, 52px);
  color: #7c3aed;
  flex: 0 0 auto;
`;

AiAvatar.defaultProps = {
  'aria-hidden': 'true',
};

export default AiAvatar;
